export const GET_SYSTEM_AUTH_PROVIDERS = 'GET_SYSTEM_AUTH_PROVIDERS';
export const SET_SYSTEM_AUTH_PROVIDERS = 'SET_SYSTEM_AUTH_PROVIDERS';
export const SET_ACTION_BUTTON_ACTIVE = 'SET_ACTION_BUTTON_ACTIVE';